import { render, staticRenderFns } from "./exinfo.vue?vue&type=template&id=4f5decfb&scoped=true&"
import script from "./exinfo.vue?vue&type=script&lang=js&"
export * from "./exinfo.vue?vue&type=script&lang=js&"
import style0 from "./exinfo.vue?vue&type=style&index=0&id=4f5decfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5decfb",
  null
  
)

export default component.exports